import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
// import Game from '../views/Game.vue';
// import JoinUsSocial from "../views/JoinUsSocial.vue";
// import About from "../views/About.vue";
// import Privacy from "../views/Privacy.vue";
// import Terms from "../views/Terms.vue";
// import DataDelete from "../views/DataDelete.vue";
// import Associates from "../views/Associates.vue";

Vue.use(VueRouter);

const UseGame = () =>
  System.import(/* webpackChunkName: "game" */ "../views/Game.vue");
const UseJoinUsSocial = () =>
  System.import(
    /* webpackChunkName: "join_social" */ "../views/JoinUsSocial.vue"
  );
const UseAbout = () =>
  System.import(/* webpackChunkName: "about" */ "../views/About.vue");

const UsePrivacy = () =>
  System.import(/* webpackChunkName: "join_social" */ "../views/Privacy.vue");
const UseTerms = () =>
  System.import(
    /* webpackChunkName: "join_social_details" */ "../views/Terms.vue"
  );
const UseDataDelete = () =>
  System.import(/* webpackChunkName: "about" */ "../views/DataDelete.vue");
// const UseAssociates = () =>
//   System.import(/* webpackChunkName: "about" */ "../views/Associates.vue");

const Echics = () =>
  System.import(/* webpackChunkName: "about" */ "../views/Echics.vue");

const CookieNotice = () =>
  System.import("../views/CookieNotice.vue");

const routes = [
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/game",
    name: "game",
    component: UseGame,
  },
  {
    path: "/data_delete",
    name: "data_delete",
    component: UseDataDelete,
  },
  {
    path: "/ethics",
    name: "ethics",
    component: Echics,
  },
  {
    path: "/join_social",
    name: "join_social",
    component: UseJoinUsSocial,
  },
  {
    path: "/about",
    name: "about",
    component: UseAbout,
  },
  {
    path: "/privacy",
    name: "privacy",
    component: UsePrivacy,
  },
  {
    path: "/terms",
    name: "terms",
    component: UseTerms,
  },
  {
    path: "/cookie_notice",
    name: "cookie_notice",
    component: CookieNotice,
  }
  // {
  //   path: "/associates",
  //   name: "associates",
  //   component: UseAssociates,
  // },
];

const router = new VueRouter({
  mode: "history",
  routes: routes,
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js